import { Button, ButtonProps } from "@chakra-ui/react"
// import { useColorModeValue } from "@pathwright/ux/src/components/chakra/ui/color-mode"
import { useFormikContext } from "formik"

const AuthFormButton = (
  props: ButtonProps & { loading: boolean }
): JSX.Element => {
  const { loading, ...rest } = props
  const form = useFormikContext()

  return (
    <Button
      variant="solid"
      colorPalette="brand"
      type="submit"
      width="full"
      loading={loading && form.isValid}
      disabled={
        loading || !form.isValid || (!form.dirty && !form.validateOnMount)
      }
      {...rest}
    />
  )
}

export default AuthFormButton
